import { doc, getDoc, setDoc, collection, query, where, getDocs, limit } from "firebase/firestore";
import { db } from "../lib/firebase";

const SETTINGS_COLLECTION = "settings";
const HOMEPAGE_DOC = "homepage";

export const getHomepageConfig = async () => {
    try {
        const ref = doc(db, SETTINGS_COLLECTION, HOMEPAGE_DOC);
        const snap = await getDoc(ref);
        if (snap.exists()) {
            return snap.data();
        }
        // Return default structure if not exists
        return {
            featuredProducts: [], // { id, order }
            campaigns: [], // { id, title_en, title_tr, ... }
            dealOfDay: { isActive: false }
        };
    } catch (error) {
        console.error("Error fetching homepage config:", error);
        throw error;
    }
};

export const updateHomepageConfig = async (data) => {
    try {
        const ref = doc(db, SETTINGS_COLLECTION, HOMEPAGE_DOC);
        await setDoc(ref, data, { merge: true });
        return true;
    } catch (error) {
        console.error("Error updating homepage config:", error);
        throw error;
    }
};

export const searchProducts = async (searchText) => {
    if (!searchText || searchText.length < 2) return [];

    // Note: Firestore doesn't support native fuzzy search. 
    // This is a basic implementation. For production, consider Algolia/Meilisearch 
    // or exact match/prefix match if possible. 
    // Here we'll fetch a batch and filter client-side for "contains" behavior 
    // since we don't have a dedicated search service.

    const ref = collection(db, "products");
    const q = query(ref, limit(50)); // Fetch subset
    const snap = await getDocs(q);

    const lowerSearch = searchText.toLowerCase();

    return snap.docs
        .map(d => ({ id: d.id, ...d.data() }))
        .filter(p => p.name && p.name.toLowerCase().includes(lowerSearch))
        .slice(0, 10);
};

export const getProductById = async (id) => {
    const ref = doc(db, "products", id);
    const snap = await getDoc(ref);
    if (snap.exists()) return { id: snap.id, ...snap.data() };
    return null;
};
